module.exports = __webpack_public_path__ + "media/images/sale_crm/tickets-514ecfebfb7dd890af59e071869ed56e.svg";